// extracted by css-extract-rspack-plugin
export default {"cardBody":"Alerts__cardBody--GS5zp"};